<div class="subscription-block">
  <div class="white-box">
    <div class="table-title">
      <h5>Subscription plans</h5>
      <p>View your subscription plans.</p>
    </div>
    <div class="table-container">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Plans</th>
              <th scope="col">Price($)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Registration price</td>
              <td>500</td>
            </tr>
            <tr>
              <td>Renew</td>
              <td>50 per month</td>
            </tr>
            <tr>
              <td>Service charge</td>
              <td>50 per month</td>
            </tr>
            <tr>
              <td>Commision charge</td>
              <td>50 per package sales</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
